import { IonIcon, IonModal, IonRow } from "@ionic/react";
import "./PopupModal.css";
import { close } from "ionicons/icons";

interface PathCardProps {
  children: JSX.Element;
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
}

const PopupModal: React.FC<PathCardProps> = ({
  children,
  isOpen,
  setIsOpen,
}) => {
  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={() => setIsOpen(false)}
      className="PopupModal"
    >
      <div className="wrapper">
        {" "}
        <IonRow className="ion-justify-content-end">
          <IonIcon
            icon={close}
            className="PopupModal-close"
            onClick={() => setIsOpen(false)}
          />
        </IonRow>
        {children}
      </div>
    </IonModal>
  );
};

export default PopupModal;
